import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); toast.success("Welcome back"); nav("/dashboard"); }
    catch (ex) { setErr(errMsg(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="hidden flex-col justify-between bg-primary p-12 lg:flex">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[hsl(var(--brand-accent))]">Realtytics · Sales CRM</p>
        <div>
          <h1 className="max-w-md text-4xl font-extrabold leading-tight text-white lg:text-5xl">One sales operating system. Four verticals.</h1>
          <p className="mt-4 max-w-md text-emerald-50/80">Track every call, follow-up, meeting and rupee — from first touch to collection — across BMS, Intl, Ind and CRM.</p>
          <div className="mt-10 flex gap-2">
            {["BMS", "Intl", "Ind", "CRM"].map((v) => <span key={v} className="rounded-full border border-white/20 px-3 py-1 text-xs font-semibold text-white">{v}</span>)}
          </div>
        </div>
        <p className="text-xs text-emerald-50/60">Internal use only · Access is restricted to authorised sales staff</p>
      </div>
      <div className="flex items-center justify-center bg-white p-6">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <img src="/logo-crop.png" alt="Realtytics — Where Real Estate Meets Real Results" className="mx-auto mb-8 w-64" data-testid="login-logo" />
          <h2 className="text-2xl font-bold text-slate-900">Sign in</h2>
          <p className="mt-1 text-sm text-muted-foreground">Use your company sales account</p>
          <div className="mt-8 space-y-4">
            <label className="block"><span className="crm-label">Email</span>
              <input data-testid="login-email-input" type="email" required className="crm-input h-11" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
            </label>
            <label className="block"><span className="crm-label">Password</span>
              <input data-testid="login-password-input" type="password" required className="crm-input h-11" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </label>
            {err && <p data-testid="login-error" className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700">{err}</p>}
            <button data-testid="login-submit-button" disabled={busy} className="h-11 w-full rounded-md bg-primary font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
